<div class="form-group">
    <label class="input-label">Label name:</label>
    <input type="text"
           name="fieldOptions.label"
           value="{{fieldOptions.label}}"
           [(ngModel)]="fieldOptions.label"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>